"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationWithKetteGuard = void 0;
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
class ConfigurationWithKetteGuard {
    static hasKette(configuration) {
        return configuration.hasAnyKette();
    }
    static hasGeneratedKette(configuration) {
        return configuration.hasGeneratedKette();
    }
    static hasFillableKette(configuration) {
        return echain_shared_articles_oo_1.FillableKetteGuard.isFillable(configuration.kette);
    }
}
exports.ConfigurationWithKetteGuard = ConfigurationWithKetteGuard;
//# sourceMappingURL=ConfigurationWithKette.js.map